import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import { globalNavSliceName } from "./slice"

const root = (s: RootState) => s[globalNavSliceName]

export const selectIsWorkspaceSwitcherOpen = createSelector(
    [root],
    (s) => s.isWorkspaceSwitcherOpen
)
export const selectIsAccountPopoutOpen = createSelector([root], (s) => s.isAccountPopoutOpen)
